import { Redirect } from 'react-router-dom';

const RedirectArchive = () => {
    return <Redirect to="/archive" />;
};

export default RedirectArchive;
